import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleFill, PiCircleFill } from 'react-icons/pi';
import './CreatedWithAiSelectCard.scss';

interface ICreatedWithAiSelectCardProps {
  createdWithAi: boolean;
  isSelected?: boolean;
  onClick?: (createdWithAi: boolean) => void;
  disabled?: boolean;
}

const CreatedWithAiSelectCard = ({
  createdWithAi,
  isSelected,
  onClick,
  disabled,
}: ICreatedWithAiSelectCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames('created-with-ai-select-card', { isSelected, disabled })}
      onClick={() => !disabled && onClick && onClick(createdWithAi)}
    >
      <div className="created-with-ai-select-card-header">
        <div className="created-with-ai-select-card-header-name">
          {t(`created-with-ai.${String(createdWithAi)}.name`)}
        </div>
        <div className="created-with-ai-select-card-header-description">
          {t(`created-with-ai.${String(createdWithAi)}.description`)}
        </div>
      </div>
      {isSelected ? <PiCheckCircleFill /> : <PiCircleFill />}
    </div>
  );
};

export default CreatedWithAiSelectCard;
